var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.apiSettings.length !== 0)?_c(_setup.NcAppSettingsSection,{attrs:{"id":"api-settings","name":_setup.t('files', 'Additional settings')}},_vm._l((_setup.apiSettings),function(setting){return _c(_setup.FilesAppSettingsLegacyApiEntry,{key:setting.name,attrs:{"setting":setting}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }